/**
 * 已开启插件的配置
 */
const plugConfig = {
  namespaced: true,
  state: () => ({}),
  mutations: {
    save(state, { payload }) {
      if (!payload || !Object.keys(payload).length) return;
      for (const key in payload) {
        Vue.set(state, key, payload[key])
      }
    },
  }
}

export default plugConfig
